module.exports = __webpack_public_path__ + "static/23-2300310411bc3b0c756b339f4ce8c691.png";